import { ModaSofa } from '@dora/backpack';
import * as E from 'fp-ts/Either';
import * as Selectors from '../store/selectors';
import * as S from '../store';
import * as Summary from './summary';

export { ModaSofa };

/**
 *  Select a template based on a Sofa config. Fails if templates are not yet resolved.
 */
export const templateFromConfig = (
    config: ModaSofa.Configuration,
): E.Either<string, ModaSofa.Templates> => {
    const templates = Selectors.ModaSofa.templates(S.store.getState());

    if (templates === null) {
        return E.left('failed to add modular sofa, modular sofa templates not yet initialised');
    } else {
        return E.right(templates[config.templateKey]);
    }
};

export const summary = (
    template: ModaSofa.Templates,
    config: ModaSofa.Configuration,
    range: string,
) =>
    Summary.create({
        name: ModaSofa.generateName(template.kind, config, range),
        image: `assets/sofas/${ModaSofa.selectThumbnailName(template.kind, config)}`,
    });
